import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Tooltip,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';

const BranchListItem = function BranchListItem({
  branch = {},
  onRemoveClick = () => {},
  onSwitchClick = () => {},
  isDefault = false,
}) {
  const intl = useIntl();

  return (
    <ListItem divider>
      <ListItemIcon>
        <BusinessRoundedIcon color="primary" />
      </ListItemIcon>
      <ListItemText
        id={`branch-${branch?.branchDescription}-list-item`}
        primary={branch?.branchDescription}
      />
      <ListItemSecondaryAction
        style={{
          textAlign: 'end',
        }}
      >
        <Tooltip title={intl.messages.SET_DEFAULT}>
          <Switch
            edge="start"
            onChange={onSwitchClick}
            checked={isDefault}
            inputProps={{
              'aria-labelledby': 'switch-list-default-branch',
            }}
          />
        </Tooltip>
        <Tooltip title={intl.messages.REMOVE}>
          <IconButton onClick={onRemoveClick}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

BranchListItem.propTypes = {
  branch: PropTypes.object,
  onRemoveClick: PropTypes.func,
  onSwitchClick: PropTypes.func,
  isDefault: PropTypes.bool,
};

export default BranchListItem;
